<section class="gradient-section-theme-color1">
  <div class="container">
    <h1>
      Age Calculator
    </h1>
  </div>
</section>

<div class="col-xs-12" style="height:50px;"></div>

<div class="container">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/">Home</a></li>
      <li class="breadcrumb-item"><a href="/tools">Tools</a></li>
      <li class="breadcrumb-item active" aria-current="page">Age Calculator</li>
    </ol>
  </nav>

  <div class="mt-5">
    <div class="tab-content" id="myTabContent">
      <div class="card mt-5">
        <div class="card-header">
          <h3>Age Calculator</h3>
        </div>
        <div class="card-body">
          <p>Use this tool to calculate your age. Enter your birth date to see your age in years, months,
          and days.</p>

          <form (ngSubmit)="calculateDifference()" #ageForm="ngForm">
            <div class="form-group">
              <label for="startDate">Birth Date:</label>
              <input type="date" class="form-control" id="startDate" name="startDate"
                [(ngModel)]="startDate" required ngModel>
            </div>

            <div class="form-group mt-3">
              <button type="submit" class="btn btn-primary">Calculate</button>
              <button type="button" class="btn btn-secondary" (click)="resetForm()">Reset</button>
            </div>
          </form>

          @if (ageForm.submitted) {
            <div class="mt-3">
              <p>Calculating Age for Birth Date: <strong>{{ startDate }}</strong></p>
            </div>
          }

          @if (ageForm.submitted) {
            <div class="mt-3">
              <h3>Your Age</h3>
              <div class="mt-3">
                <table class="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Years</th>
                      <th>Months</th>
                      <th>Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ differenceHumanReadable.years }}</td>
                      <td>{{ differenceHumanReadable.months }}</td>
                      <td>{{ differenceHumanReadable.days }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          }
          @if (ageForm.submitted) {
            <div class="mt-3">
              <h3>Age Table</h3>
              <div class="mt-3">
                <table class="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Year</th>
                      <th>Age</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (year of ageTable; track year) {
                      <tr>
                        <td>{{ year.year }}</td>
                        <td>{{ year.age }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

  </div>
</div>

<div class="col-xs-12" style="height:50px;"></div>
